import React from 'react';
import './ui.css';

const Skeleton = ({ width = '100%', height = 20, borderRadius = 8, className = '', style = {} }) => (
  <div
    className={`pn-skeleton ${className}`.trim()}
    style={{ width, height, borderRadius, ...style }}
    aria-hidden="true"
  />
);

export const SkeletonRow = ({ className = '' }) => (
  <div className={`pn-skeleton-row ${className}`.trim()} style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '16px 0' }}>
    <Skeleton width={20} height={20} borderRadius={10} />
    <Skeleton width="70%" height={16} />
    <Skeleton width={16} height={16} />
  </div>
);

export default Skeleton;
